import RequestAQuote from './pages/RequestAQuote.vue';
import RequestAQuoteRules from './pages/RequestAQuoteRules.vue';
import NewRequestQuote from './pages/NewRequestQuote.vue';
import NewQuoteRules from './pages/NewQuoteRules.vue';

dokan_add_route(RequestAQuote);
dokan_add_route(RequestAQuoteRules);
dokan_add_route(NewRequestQuote);
dokan_add_route(NewQuoteRules);
